import { USERS_ROUTES } from '@/views/Users/utils'
import { FILES_ROUTES } from '@/views/Files/utils'
import { PublicationStorageFileHistory as Data } from '@/typings/api/Publication'

import { dateFormatter } from '@/helpers/dateFormatter'


export const TABLE_ACTIONS = Object.freeze([
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Регион',
    value: 'region.code',
    sortable: false,
  },
  {
    text: 'Муниципалитет',
    value: 'municipality.code',
    sortable: false,
  },
  {
    text: 'ОО',
    value: 'school.code',
    sortable: false,
  },
  {
    text: 'Логин',
    value: 'user.username',
    sortable: false,
    getRoute: (v: Data) => ({
      name: USERS_ROUTES.VIEW,
      params: {
        id: v.user.id,
      },
    }),
  },
  {
    text: 'Файл',
    value: 'storage_file.filename',
    sortable: false,
    getRoute: (v: Data) => ({
      name: FILES_ROUTES.VIEW,
      params: {
        id: v.storage_file.id,
      },
    }),
  },
  {
    text: 'IP',
    value: 'ip_address',
    sortable: false,
    width: 110,
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 130,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
])
